import { Fragment } from "react";

import { EmojiRenderer } from "@/react/components/shared/EmojiRenderer";
import { customEmojiShapeUrl } from "@/react/components/shared/uikit/EmojiPickerV3/data/shapes";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { activeStorageBlobUrl } from "@/react/helpers/urlHelpers";
import { APPEARANCE } from "@/react/providers/Theme";
import {
  type CustomIcon,
  EMOJI_TYPE,
  type EmojiIcon,
  type ShapeIcon,
} from "@/react/types/PaywallCustomization";
import type { BadgeProperty } from "@/react/types/PaywallCustomization";

interface IconProps {
  dataTestId?: string;
  icon: BadgeProperty["icon"];
}

export const Icon = ({ icon, dataTestId }: IconProps) => {
  const { emoji_type } = icon;
  let emojiRendererProps = {};
  const appearance = APPEARANCE.LIGHT;

  if (emoji_type === EMOJI_TYPE.EMOJI) {
    const { emoji } = icon as EmojiIcon;

    emojiRendererProps = {
      className: classNames("!w-6 !p-0"),
      emptyIcon: Fragment,
      emoji: emoji,
    };
  }

  if (emoji_type === EMOJI_TYPE.CUSTOM) {
    emojiRendererProps = {
      className: classNames("!w-6 !p-0 !pr-1"),
      emptyIcon: Fragment,
      customEmojiUrl: activeStorageBlobUrl(icon as CustomIcon),
      customEmojiDarkUrl: activeStorageBlobUrl(icon as CustomIcon),
    };
  }

  if (emoji_type === EMOJI_TYPE.SHAPES) {
    const { identifier } = icon as ShapeIcon;

    emojiRendererProps = {
      className: classNames("!w-4 !p-0 !pr-1"),
      emptyIcon: Fragment,
      customEmojiUrl: customEmojiShapeUrl(identifier) || null,
      customEmojiDarkUrl: customEmojiShapeUrl(identifier) || null,
    };
  }

  return (
    <span data-testid={dataTestId}>
      <EmojiRenderer {...emojiRendererProps} appearance={appearance} />
    </span>
  );
};
